
export default {
  name: 'SectionHeaderSlice',
  props: ['slice'],
  data() {
    return {
      id: `${this.slice.id.replace('$','')}-trustbox`,
      widgetHeight: 'auto'
    }
  },
  computed: {
    locale(){
      return this.$i18n.locale === 'it' ? 'it-IT' : 'en-US'
    },
    reviewLanguages(){
      return this.$i18n.locale === 'it' ? 'it' : 'en'
    },
    templateId() {
      switch(this.slice.primary.type) {
        case 'horizontal':
          this.widgetHeight = "28px"
          return '5406e65db0d04a09e042d5fc'
        case 'carousel':
          this.widgetHeight = "140px"
          return '53aa8912dec7e10d38f59f36'
        case 'slider':
          this.widgetHeight = "240px"
          return '54ad5defc6454f065c28af8b'
        case 'mini-carousel':
          this.widgetHeight = "350px"
          return '539ad0ffdec7e10e686debd7'
        case 'list':
          this.widgetHeight = "500px"
          return '539ad60defb9600b94d7df2c'
        case 'grid':
          this.widgetHeight = "500px"
          return '539adbd6dec7e10e686debee'
        case 'micro-combo':
          this.widgetHeight = "20px"
          return '5419b6ffb0d04a076446a9af'
        case 'mini':
          this.widgetHeight = "150px"
          return '53aa8807dec7e10d38f59f32'
        default:
          this.widgetHeight = "140px"
          return '53aa8912dec7e10d38f59f36'
      }
    }
  },
  mounted(){
    const trustbox = document.getElementById(this.id)
    window?.Trustpilot?.loadFromElement(trustbox)
  }
}
